export default {
    report_overview_title: "Reporte",
    report_overview_name: "Reporte",
    report_overview_execute_report: "Ejecutar Reporte",
    report_overview_export_report: "Exportar Reporte",
    report_overview_filters: "Filtros",
    report_overview_dealer: "Dealer",
    report_overview_account: "Account",
    report_overview_customer: "Customer",
    report_overview_schedule_report:"Programar este reporte",
    report_overview_creation_date_filter:"Filtro Fecha Creación",
    report_overview_after:"Después",
    report_overview_before:"Antes",
    report_overview_missing:"Falta",
    report_overview_execute_error:"Hubo un error ejecutando el reporte",
    report_overview_export_error:"Hubo un error exportando el reporte",

    report_overview_unit_status_ddl:"Estado de la Unidad",
    report_overview_unit_status_active: "Activo",
    report_overview_unit_status_voluntary_suspended: "Suspención Voluntaria",
    report_overview_unit_status_involuntary_suspended: "Suspención Involuntaria",
    report_overview_unit_status_cancelled: "Cancelada",
    report_overview_unit_status_rma: "RMA",
    report_overview_select_filter: "Seleccione un filtro",
    
    "report_overview_SIMOwner(Dealer)": "Propietario de SIM (Distribuidor)",
    report_overview_CompanyName: "Nombre de la empresa",
    report_overview_AccountStatus: "Estado de la cuenta",
    report_overview_IMEI: "IMEI",
    report_overview_SerialNumber: "Número de serie",
    report_overview_ShowonSite: "Mostrar en el sitio",
    report_overview_SIMNumber: "Número SIM",
    report_overview_SIMPhoneNumber: "Número de teléfono SIM",
    report_overview_SIMStatus: "Estado de la SIM",
    report_overview_SIMOwner: "Propietario de SIM",
    report_overview_Account: "Cuenta",
    report_overview_AccountStatus: "Estado de la cuenta",
    report_overview_Network: "Red",
    report_overview_Manufacturer: "Fabricante",
    report_overview_DeviceModel: "Modelo de dispositivo",
    report_overview_DeviceFamily: "Familia del dispositivo",
    report_overview_ESN: "ESN",
    report_overview_ICCID: "ICCID",
    report_overview_MSISDN: "MSISDN",
    report_overview_DeviceStatus: "Estado del dispositivo",
    report_overview_Dealer: "Distribuidor",
    report_overview_Active: "Activo",
    report_overview_VoluntarySuspension: "Suspensión voluntaria",
    report_overview_InvoluntarySuspension: "Suspensión involuntaria",
    report_overview_Cancelled: "Cancelado",
    report_overview_RMA: "RMA",
    report_overview_Label: "Etiqueta",
    report_overview_SIMProviderAccount: "Cuenta de proveedor SIM",
    report_overview_UnitStatus: "Estado de la unidad",
    report_overview_unitId: "Id de unidad",
    report_overview_unitLabel: "Nombre de la unidad",
    report_overview_esn: "Serial",
    report_overview_lastMessageTime: "Hora del último mensaje",
    report_overview_unitTime: "Unidad de Tiempo",
    report_overview_serverTime: "Hora del servidor",
    report_overview_ageHours: "Edad",
    report_overview_companyName: "Cuenta",
    report_overview_mostRecentMessageTime: "Hora del mensaje más reciente",
    report_overview_activeUnits: "Unidades Activas",
    report_overview_offlineUnits: "Unidades Offline",
    report_overview_percentage: "Porcentaje",
    report_overview_date: "Fecha",
    report_overview_warning: "Advertencia",
    report_overview_devices: "Dispositivos",
    report_overview_company: "Cuenta",
    report_overview_type: "Tipo",
    report_overview_value: "Valor",
    report_overview_label: "Nombre",
    report_overview_activeAccounts: "Cuentas Activas",
    report_overview_activeDevices: "Dispositivos Activos",
    report_overview_startDate: "Rango de Fechas",
    "Offline Days":"Días fuera de línea",

    report_overview_fuelcard_id: "Id de la Tarjeta",
    report_overview_company_id: "Id de la Compañía",
    report_overview_company_name: "Nombre de la Compañía",
    report_overview_company_code: "Codigo de Compañia",
    report_overview_account_code: "Código de Cuenta",
    report_overview_processor: "Procesador",
    report_overview_fleet_code: "Código de Flota",
    report_overview_provider: "Proveedor",
    report_overview_card_number: "Número de Tarjeta",
    report_overview_vehicle_id: "Id del Vehículo",
    report_overview_vehicle_description: "Descripcion del Vehiculo",
    report_overview_created_date: "Fecha de Creación",
    report_overview_created_at: "Creado En",
    report_overview_updated_at: "Actualizado En",
    report_overview_transactions_count: "Recuento de Transacciones",
    SAVED: "Guardado",
    INACTIVE: "Inactivo",
    ACTIVE: "Activo",
    report_overview_cardNumber: "Número de Tarjeta",
    report_overview_siteName: "Nombre del Sitio",
    report_overview_vehicleDesc: "Vehículo Description",
    report_overview_transactionDate: "Fecha de la transacción",
    report_overview_postDate: "Fecha de Publicación",
    report_overview_createdAt: "Creado en",
    report_overview_updatedAt: "Actualizado en",
    report_overview_compId: "Id de la Compañía",
    report_overview_compName: "Nombre de la Compañía",
    report_overview_fuelcardId: "Id de la Tarjeta",
    report_overview_accountCode: "Código de Cuenta",
    report_overview_vehicleId: "Id del Vehículo",
    report_overview_createdDate: "Fecha de Creación",
    report_overview_vehicleDescription: "Descripcion del Vehículo",
    report_overview_created: "Creado",
    report_overview_companyStatus: "Estado de la Compañía",
    report_overview_hasPerm: "Tiene Perm.",
    report_overview_fcCompanyCode: "Código de la Compañía FC",
    report_overview_numberCards: "Número de Tarjetas",
    report_overview_cardLastReceivedDate: "Fecha de Recepción de la Tarjeta",
    report_overview_duplicates: "Duplicados",
    report_overview_numberTrans: "Números de Trans.",
    report_overview_transLastReceivedDate: "Trans. Última Fecha de Recepción",
    report_overview_compID: "Id de la Compañía",
    report_overview_dupCount: "Número de Duplicados",   
    report_overview_lastTimeCreated: "Última vez Creado",
    report_overview_select_calendar: ", seleccione el calendario y haga clic en el botón aplicar",
    report_overview_processedUnits: "Unidades Procesadas",
    report_overview_totalUnits: "Total de Unidades",
    report_overview_ftpStatus: "Estado FTP",
    report_overview_filesize: "Tamaño del Archivo",
    report_overview_dateProcessed: "Fecha de Procesamiento",
    report_overview_startDateTime: "Fecha de Inicio",
    report_overview_endDateTime: "Fecha Final",
    report_overview_reTry: "Procesar",
    report_overview_activeMonths: "Meses Activo",
    report_overview_initialRegistration: "Registro Inicial",
    report_overview_lastRegistered: "Ultimo Registro",
    report_overview_registeredOnWaylens: "Registrado en Waylens",
    report_overview_environment: "Ambiente",
    report_overview_lastReportEvent: "Ultimo Evento Reportado",
    report_overview_installed: "Instalado",
    report_overview_tagIds: "Etiquetas",
    report_overview_range_message: "El rango de fechas solo es plaicado cuanto selecciona el rango o cuando lo has seleccionado previamente",
    report_overview_eventId: "Id del Evento",
    report_overview_eventName: "Nombre del Evento",
    report_overview_deviceIddr: "Id del Dispositivo",
    report_overview_clipId: "Id del Clip",
    report_overview_currentStatus: "Estado Actual",
    report_overview_createdBy: "Creado Por",
    report_overview_reviewedBy: "Revisado Por",
    report_overview_review_date: "Fecha de Revisión",
    report_overview_event_date: "Fecha del Evento",
    report_overview_eventDate: "Fecha del Evento",
    report_overview_eventType: "Tipo de Evento",
    report_overview_dateRangeBy: "Rango de Fechas Por",
    "ESN": "ESN",
    "Event Id": "Id del Evento",
    "Event Name": "Nombre del Evento",
    "Device Id": "Id del Dispositivo",
    "Clip Id": "Id del Clip",
    "Old Status": "Estado Anterior",
    "New Status": "Nuevo Estado",
    "Note": "Nota"
};